import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GroupInput } from '../../../../components/GroupInput/GroupInput';
import { START_TO_TYPE } from '../consts';
import { getServiceFilter, getServiceSelected } from '../../../store/selectors';
import { selectSubGroup, setBookingError } from '../../../store/serviceSlice';

export const SubgroupSelector = ({ onSelect }) => {
    const { subGroups: selected = '' } = useSelector(getServiceSelected);
    const { subGroups: data = [] } = useSelector(getServiceFilter);
    const dispatch = useDispatch();

    const getMetadata = useCallback(() => {
        return data.map((item) => {
            const id = (item?.id ? item.id : item?.name);
            const code = (item?.code ? item?.code : item?.name);
            return {
                ...item,
                id,
                code,
            };
        });
    }, [data]);

    const onChangeHandler = (value) => {
        dispatch(setBookingError(''));
        if (onSelect) {
            if (onSelect(value)) {
                dispatch(selectSubGroup(value));
            }
        } else {
            dispatch(selectSubGroup(value));
        }
    };
    return <>
        <GroupInput
            type="selector"
            label="Раздел"
            placeholder={START_TO_TYPE}
            value={selected}
            onChange={onChangeHandler}
            metaData={getMetadata()}
            onClear={() => onChangeHandler('')}
            id="subgroup"
        />
    </>;
};
